import * as React from 'react';
import { connect, Dispatch } from 'react-redux';
import { RootState } from 'src/reducers/RootReducer';
import { openModal, OpenModal } from 'src/actions/modal';
import Modal from 'src/modules/commons/modal-handler/jQueryModal';
import ModifyContractsComponent, { ModifyContractsComponentProps }
  from 'src/modules/modals/modify-contracts/ModifyContracts.component';
import ContractCorrections from 'src/value-objects/ContractCorrections';
import {
  createContractCorrection,
  CreateCorrectionContractAction
} from 'src/actions/contract-corrections/create/CreateContractCorrections.actions';
import * as ContractCorrectionsTypes from 'src/actions/contract-corrections/create/Types';
import Investment from 'src/entities/Investment';

interface StateProps {
  errorMessage: {};
}

interface DispatchProps {
  openModal: (content: JSX.Element) => void;
  createContractCorrection: (investmentId: number, contractCorrection: ContractCorrections) =>
    Promise<CreateCorrectionContractAction>;
}

interface Props extends StateProps, DispatchProps {
  modalRef?: Modal;
  investment: Investment;
  correctionCreated: () => void;
}

interface State {
  optionTypes: { name: string, value: string }[];
  typeError: string;
  errorDescription: string;
}

class ModifyContractsContainer extends React.Component<Props, State> {

  public state = {
    optionTypes: [
      {name: 'Los dos contratos', value: 'Both'},
      {name: 'contrato de sindicación', value: 'Syndicate Agreement'},
      {name: 'pacto de socios', value: 'Shareholder Agreement'}
    ],
    typeError: '',
    errorDescription: ''
  };

  public render(): React.ReactNode {
    return <ModifyContractsComponent {...this.getComponentProps()}/>;
  }

  private handleChange(key: string): (value: string | boolean | File) => void {
    return (value: string | boolean) => {
      const newState = {};
      newState[key] = value;
      this.setState(newState);
    };
  }

  private handleSubmit(): void {
    let value: string;
    switch (this.state.typeError) {
      case 'Los dos contratos':
        value = 'Both';
        break;
      case 'contrato de sindicación':
        value = 'Syndicate Agreement';
        break;
      case 'pacto de socios':
        value = 'Shareholder Agreement';
        break;
      default:
        value = 'Both';
    }

    const formData = {
      typeError: value,
      errorDescription: this.state.errorDescription
    };
    this.props.createContractCorrection(this.props.investment.id!, formData)
      .then((response: CreateCorrectionContractAction) => {
        if (response.type === ContractCorrectionsTypes.CREATE_CORRECTION_CONTRACT_SUCCESS) {
          this.props.correctionCreated();
          this.props.modalRef!.modal('hide');
        }
      });
  }

  private getComponentProps(): ModifyContractsComponentProps {
    return {
      handleChange: (key: string) => this.handleChange(key),
      handleSubmit: () => this.handleSubmit(),
      optionTypes: this.state.optionTypes,
      typeError: this.state.typeError,
      errorDescription: this.state.errorDescription,
      modalRef: this.props.modalRef!,
      errorMessage: this.props.errorMessage
    };
  }
}

const mapDispatchToProps: (dispatch: Dispatch<RootState>) => DispatchProps = (
  dispatch: Dispatch<RootState>
): DispatchProps => {

  return {
    openModal: (content: JSX.Element): OpenModal => {
      return dispatch(openModal(content));
    },
    createContractCorrection: (investmentId: number, contractCorrection: ContractCorrections):
      Promise<CreateCorrectionContractAction> => {
      return dispatch(createContractCorrection(investmentId, contractCorrection));
    }
  };
};

const mapStateToProps: (state: RootState) => StateProps = (state: RootState): StateProps => ({
  errorMessage: state.createCorrectContract.errorMessage
});

export default connect(mapStateToProps, mapDispatchToProps)(ModifyContractsContainer);



// WEBPACK FOOTER //
// ./src/modules/modals/modify-contracts/ModifyContracts.container.tsx